import type React from 'react';
import { Controller } from 'react-hook-form';
import { Form, Input } from 'antd';
import type { FieldValues } from 'react-hook-form';
import type { RHFBaseProps, CommonChrome } from './types';
import { DEFAULT_FORM_LAYOUT } from './constants';

type InputOTPProps = React.ComponentProps<typeof Input.OTP>;

export type ControlledOTPInputProps<TFieldValues extends FieldValues = FieldValues> =
  RHFBaseProps<TFieldValues> & CommonChrome & Omit<InputOTPProps, 'value' | 'onChange'>;

export function ControlledOTPInput<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  required,
  disabled,
  help,
  layout,
  fieldClassName,
  ...rest
}: ControlledOTPInputProps<TFieldValues>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <Form.Item
          label={label}
          required={required}
          validateStatus={fieldState.error ? 'error' : undefined}
          help={fieldState.error?.message ?? help}
          layout={layout ?? DEFAULT_FORM_LAYOUT}
          className={fieldClassName}
        >
          <Input.OTP
            {...rest}
            value={value ?? ''}
            onChange={onChange}
            disabled={disabled}
          />
        </Form.Item>
      )}
    />
  );
}
